import { Image } from "@chakra-ui/react";
import JavaIcon from "./java.svg";
interface Props {
  color?: string;
  boxSize?: string;
}
export const Java = (props: Props) => <Image boxSize={props.boxSize} src={JavaIcon} />;

export default Java;
